import { CURRENT_ACTIVATION_FEE, isCurrentTierActivationFee } from "./membershipConfig";

/**
 * Profit margin pool for 10-level referral points on flat Ultra membership (₹649 / ₹699).
 * Total points when full chain qualifies = margin × 180% = ₹180 at ₹100 margin.
 */
export const FLAT_MEMBERSHIP_REFERRAL_PROFIT_MARGIN = 100;

export function isFlatMembershipPackage(packageData, packagePrice) {
  if (packageData?.isSubItemPackage) return false;
  const price = Number(packagePrice ?? packageData?.price);
  const fee = Number(packageData?.activationFee ?? price);
  return isCurrentTierActivationFee(fee) || price === CURRENT_ACTIVATION_FEE;
}

/** Referral fields stored on cart order package lines for commission processing. */
export function resolvePackageReferralFields(packageData, packagePrice) {
  const flatMembership = isFlatMembershipPackage(packageData, packagePrice);
  if (flatMembership) {
    return {
      referralShare: true,
      profitMargin:
        packageData?.profitMargin != null && packageData.profitMargin !== ""
          ? Number(packageData.profitMargin)
          : FLAT_MEMBERSHIP_REFERRAL_PROFIT_MARGIN,
    };
  }
  return {
    referralShare: packageData?.referralShare === true,
    profitMargin: Number(packageData?.profitMargin) || 0,
  };
}
